/* eslint-disable no-unused-vars */
import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,

  id: null,
  token: null,
  tokenExpirationDate: null,

  name: null,
  email: null,
  schools: [],
  company: null,
  brand: null,

  loaded: false,
  theme: null,
  timezones: [],
  timezone: null,
  countryCode: null,
  client: null,

  login: async () => {},
  logout: async () => {},
  UpdateTheme: (code) => {},
});
